import Backbone from "backbone";
import Marionette from "backbone.marionette";
import Xola from "../Xola";
import { Cookie } from "./Cookie";
import { Config } from "./Config";
import { Router } from "./Router";
import { Display } from "../model/Display";
import { Debug } from "./Debug";
import { fetchRecursive } from "../mixins/FetchRecursive";
import "./Application.less";

export const Application =  Marionette.Application.extend({
    region: "#app-viewport",
    routers: [],

    baseUrl: null,
    seller: null,

    initialize(options) {
        Xola.Collection.Guides.prototype.fetchRecursive = fetchRecursive;
        Config.environment = options.env || "production";
        Debug.enabled = options.debug;

        if (Debug.enabled) {
            window.config = Config;
        }

        // Initialize baseUrl
        switch (options.env) {
            case "production":
                Xola.Config.baseUrl = "https://xola.com/api";
                // Config.baseUrl.configuration = "https://xola.tv";
                Config.baseUrl.configuration = "https://tv-api.xola.com";
                Config.baseUrl.ui = options.baseUrl;
                break;

            case "sandbox":
                Xola.Config.baseUrl = "https://sandbox.xola.com/api";
                Config.baseUrl.configuration = "https://tv-api.sandbox.xola.com";
                Config.baseUrl.ui = options.baseUrl;
                break;

            case "x2":
                Xola.Config.baseUrl = "https://preprod.xola.com/api";
                Config.baseUrl.configuration = "https://x2.xola.tv";
                Config.baseUrl.ui = options.baseUrl;
                break;

            case "staging.x2":
                Xola.Config.baseUrl = "https://x2.staging.xola.com/api";
                Config.baseUrl.configuration = "http://x2.staging.xola.tv";
                Config.baseUrl.ui = options.baseUrl;
                break;

            default:
                // Xola.Config.baseUrl = "http://xola.local/api";
                // Xola.Config.baseUrl = "https://x2.staging.xola.com/api";
                // Config.baseUrl.configuration = "http://localhost:8000";
                Xola.Config.baseUrl = "https://xola.com/api";
                Config.baseUrl.configuration = "https://tv-api.xola.com";
                Config.baseUrl.ui = options.baseUrl;
        }

        // If apiKey is provided in the url, logout previous user.
        if (options.apiKey) {
            Cookie.setApiKey(null);
            Cookie.setSellerId(null);
        }

        var apiKey = options.apiKey || Cookie.getApiKey();
        if (apiKey) {
            var user = new Xola.Model.User({id: "me", apiKey: apiKey});
            Xola.setUser(user);
            Config.user = user;
        }

        var sellerId = options.seller || Cookie.getSellerId();
        if (sellerId) {
            Config.seller = new Xola.Model.Seller({id: sellerId});
        }

        var displayId = options.display || null;
        if (displayId) {
            Config.display = new Display({id: displayId});
        }
        else {
            // Special case for the VOID at Glendale - They are using a URL without display ID
            if (Config.seller && Config.seller.id == "5a96c691332e75b83a8b45a7") {
                Config.display = new Display({id: 1});
            }
        }

        Debug.log("Application.initialize():", "Initialization complete. Config:", Config);
    },

    onBeforeStart() {
        this.routers.push(new Router({viewport: this}));

        Marionette.Renderer.render = (template, data) => template.render(data);
    },

    onStart() {
        if (Xola.getUser()) {
            Debug.log("Application.onStart():", "Fetching user data before preloading the rest...");

            Xola.getUser().fetch({
                complete: () => {
                    var preloadData = [];

                    if (Config.seller) {
                        preloadData.push(Config.seller.fetch());
                        preloadData.push(Config.seller.getGuides().fetchRecursive(10));
                    }

                    if (Config.display) {
                        preloadData.push(Config.display.fetch());
                    }

                    Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
                        Debug.log("Application.onStart():", "Data preload complete. Starting...");
                        Backbone.history.start();
                    });
                }
            });
        }
        else {
            Debug.log("Application.onStart():", "Can not preload data without an API key. Starting...");
            Backbone.history.start();
        }
    }
});



// WEBPACK FOOTER //
// ./src/js/application/Application.js